import { NSARouterMakerProps, NSAHomePage } from "namirasoft-account-react";
import EmailSenderLayout from "../EmailSenderLayout";

export interface HomePageProps extends NSARouterMakerProps
{ }

function HomePage(props: HomePageProps)
{
	return (
		<EmailSenderLayout {...props}
			action={{
				title: "Namirasoft Email Sender",
				menus: {}
			}}
		>
			<NSAHomePage
				scope="Namirasoft Email Sender"
				title="Email Sending Service"
				description={"Send emails efficiently. Manage contact, schedule emails, and ensure reliable delivery to your recipients."}
				icon={"https://static.namirasoft.com/image/namirasoft/email-sender/logo/base.png"}
				notifier={props.notifier}
			/>
		</EmailSenderLayout>
	);
}

export default HomePage;